import React from "preact-compat";
import {useState} from "preact/hooks";

export default ({onClick, posts = []}) => {
    const [count, setCount] = useState(posts.length > 3 ? 6 : 3);
//img-placeholder.png
    const getImagesBlock = (countOfImages) => {
        let images = [];
        for (let i = 0; i < countOfImages; i++) {
            if (posts[i] && posts[i].thumbnail) {
                images.push(
                    <div className="image"><img src={posts[i].thumbnail} alt="Post Image"/></div>
                )
            } else if (!posts[i]) {
                images.push(<div className="image"><img src="/assets/images/img-placeholder.png" alt="Post Image"/></div>)
            }
        }
        if (posts.length > countOfImages) {
            images[count - 1] = <div className="image">
                <img src={posts[countOfImages].thumbnail} alt="Post Image"/>
                <button onClick={() => setCount(count + 3)} className="btn-more">See<br/>more</button>
            </div>
        }
        return images;
    }


    return (
        <div className="portfolio-images">
            {posts.length && <h3>Portfolio</h3>}
            {posts.length && <div className="images-list">
                {getImagesBlock(count)}
            </div>}
            <button onClick={onClick} className="btn-small leave-request-opener">
                <img src="/assets/images/icon-star.svg" alt=""/>
                <span>Book <strong>Now</strong></span>
            </button>
        </div>
    )
}